export enum DUE_STATUS_TYPE {
  DELINQUENT = 'Overdue',
  DUE_NOW = 'Due Now',
  PAST_DUE = 'Past Due'
}
export type DueStatusKey = keyof typeof DUE_STATUS_TYPE;

export enum VisitPayImhSource {
  mhios = 'mhios',
  mhand = 'mhand',
  mhweb = 'mhweb'
}

export type VisitPayImhSourceKey = keyof typeof VisitPayImhSource;
